'use client';

import Image from 'next/image';
import { Card } from '../ui/Card';
import { StoreBadges } from '../ui/StoreBadges';
import { useTranslations } from 'next-intl';

export function DownloadSection() {
  const t = useTranslations('download');

  return (
    <section className="py-20 px-4 bg-section-pink-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold leading-normal text-center mb-4 text-navy">
          {t('title')}
        </h2>
        <p className="text-xl text-foreground text-center mb-12">
          {t('subtitle')}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <Card className="bg-accent/15 border-accent/45 text-center flex flex-col items-center">
            <Image
              src="/images/safetizen-logo.svg"
              alt="Safetizen"
              width={48}
              height={48}
              className="h-12 w-auto mb-4"
              style={{ width: 'auto' }}
            />
            <h3 className="text-2xl font-bold text-foreground mb-6">Safetizen</h3>
            <StoreBadges app="safetizen" className="justify-center" />
          </Card>

          <Card className="bg-purple/12 border-purple/45 text-center flex flex-col items-center">
            <Image
              src="/images/earit-logo.svg"
              alt="Earit"
              width={48}
              height={48}
              className="h-12 w-auto mb-4"
              style={{ width: 'auto' }}
            />
            <h3 className="text-2xl font-bold text-foreground mb-6">Earit</h3>
            <StoreBadges app="earit" className="justify-center" />
          </Card>
        </div>
      </div>
    </section>
  );
}
